import { render, staticRenderFns } from "./PraticeCommunicationAndMarketingSection.vue?vue&type=template&id=10249aec"
import script from "./PraticeCommunicationAndMarketingSection.vue?vue&type=script&lang=ts"
export * from "./PraticeCommunicationAndMarketingSection.vue?vue&type=script&lang=ts"
import style0 from "./PraticeCommunicationAndMarketingSection.vue?vue&type=style&index=0&id=10249aec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports